var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('span',[_vm._v("Copyright © 2019-"+_vm._s(_vm.year)+" worldofdarts.pro Alle Rechte vorbehalten")])])}
var staticRenderFns = []

export { render, staticRenderFns }